import { createContext } from 'react';

const PedidoAppContext = createContext();

export default PedidoAppContext;
